import { render, staticRenderFns } from "./CommunicationsSupporter.vue?vue&type=template&id=5c39f7ac&scoped=true&"
import script from "./CommunicationsSupporter.vue?vue&type=script&lang=js&"
export * from "./CommunicationsSupporter.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationsSupporter.vue?vue&type=style&index=0&id=5c39f7ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39f7ac",
  null
  
)

export default component.exports